import useOutputReportStore from "../../../store/OutputReport.store";
import { definitions } from "../../../utils/resources/definitionsCopy";
import { disclosuresCopy } from "../../../utils/resources/disclosuresCopy";

import ChangePageButtons from "../../../components/ChangePageButtons";
import Definitions from "../../../components/Definitions";
import Disclosures from "../../../components/Disclosures";
import CoverPage from "../../../components/Reports/CoverPage";
import CreditQualityReport from "../../../components/Reports/CreditQualityReport";
import InterestRateAnalysisReport from "../../../components/Reports/InterestRateAnalysisReport";
import MaturityReport from "../../../components/Reports/MaturityReport";
import OneSheeterReport from "../../../components/Reports/OneSheeterReport";
import PortfolioCharacteristicsReport from "../../../components/Reports/PortfolioCharacteristicsReport";
import ProposedPortfolio from "../../../components/Reports/ProposedPortfolio";
import ScenarioAnalysisReport from "../../../components/Reports/ScenarioAnalysisReport";
import StaticPageReport from "../../../components/StaticPageReport";

const CashTreasuryBillReport = () => {
  const data = useOutputReportStore((state) => state.data);
  const types = useOutputReportStore((state) => state.types);

  const disclosuresArgs = {
    heading: "Disclosures",
    className: "report-article",
    bodyContent: [
      {
        heading: "Marketing Communication",
        content: disclosuresCopy.report.body,
      },
    ],
  };

  const definitionsArgs = {
    className: "report-article",
    bodyContent: [
      {
        heading: definitions.headings.explanation,
        gridContent: [
          definitions.portfolio,
          definitions.referenceIndex.shortTreasury,
        ],
      },
      {
        listContent: [
          {
            heading: definitions.headings.keyTerms,
            content: [
              definitions.betaToIndex,
              definitions.callable,
              definitions.coupon,
              definitions.creditQuality,
              definitions.table.creditQuality,
              definitions.effectiveDuration,
              definitions.durationTimeSpread,
              definitions.keyRateDuration,
              definitions.liquidityScore,
              definitions.maturityDate,
              definitions.optionAdjustedSpread,
              definitions.optionAdjustedSpreadDuration,
              definitions.parValue,
              definitions.price,
              definitions.timeToMaturity,
              definitions.yieldToMaturity,
              definitions.yieldToWorst,
            ],
          },
          {
            heading: definitions.headings.referenceIndex,
            content: [definitions.bloombergShortTreasury],
          },
        ],
      },
    ],
    footnote: definitions.footnote.cash,
  };

  return (
    <>
      <CoverPage />
      {data && types && (
        <>
          <StaticPageReport />
          <OneSheeterReport />
          <ProposedPortfolio />
          <PortfolioCharacteristicsReport />
          <MaturityReport />
          <CreditQualityReport />
          <InterestRateAnalysisReport />
          <ScenarioAnalysisReport />
          <Definitions {...definitionsArgs} />
          <Disclosures {...disclosuresArgs} />
        </>
      )}
      <ChangePageButtons />
    </>
  );
};

export default CashTreasuryBillReport;
